import React, { useState, useEffect } from "react";
import "./threesixtyview.css";
import BlueButton from "./BlueButton";
import APIDocsForm from "./Modals/ApiDocsForm/APIDocsForm";

function ThreeSixtyView() {
  const [isHovered, setIsHovered] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    let timer;
    if (isHovered) {
      timer = setTimeout(() => {
        setIsHovered(false);
      }, 4000);
    }

    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [isHovered]);

  return (
    <div className="threesixty-outer-container ">
      <div className="threesixty-container">
        {/* Headings for 360 view */}

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <span className="threesixty-subtext">
            Streamline your verification workflow
          </span>
          <span className="threesixty-befisc-text">
            <span>
              Be<span style={{ color: "#000" }}>yond</span>
            </span>
            <span>
              Fi
              <span style={{ color: "#000" }}>nancial</span>
            </span>
            <span>
              Sc<span style={{ color: "#000" }}>ore</span>
            </span>
          </span>
        </div>

        <div className="threesixty-explore">
          <div
            className="flexprop"
            style={{
              width: "35rem",
              gap: "1.5rem",
              fontSize: "1.1rem",
              textWrap: "wrap",
              textAlign: "center",
              zIndex: "10",
            }}
          >
            <div
              style={{
                width: "100%",
                height: "auto",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <span className="threesixty-symbol">360°</span>
              <span className="threesixty-view-text">user view</span>
            </div>
            <div
              style={{
                fontWeight: "400",
                lineHeight: "1.9rem",
                color: "#242834",
                fontFamily: "Inter",
                fontSize: "1.125rem",
              }}
            >
              With minimal user input, we provide you with a 360-degree view of
              your customers, ensuring that only genuine users are onboarded.
            </div>
            <div style={{ width: "100%" }}>
              <BlueButton
                text={"Explore 150+ APIs"}
                styles={{
                  width: "100%",
                  padding: "24px 60px",
                  background: "radial-gradient(circle, #7D47ED, #6828EB)",
                  borderRadius: "100px",
                  border: "none",
                }}
                onClick={() => setIsModalOpen(true)}
              />
            </div>
          </div>
          <img
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            src="/images/threesixtyviewimage.svg"
            alt="customer view"
            loading="lazy"
            className="image-rotater"
            style={{ animationPlayState: isHovered ? "paused" : "running" }}
          />
        </div>
      </div>
      <APIDocsForm
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        key={"three sixty view"}
      />
    </div>
  );
}

export default ThreeSixtyView;
